import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {EncryptService} from '../services/encrypt.service';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import {HttpService} from '../services/http.service';

@Injectable()
export class DecryptInterceptor implements HttpInterceptor {

  filterURL = [
    {path: `/yp-api/system/cognito/token`, fullMatch: false},
    {path: `/yp-api/system/api/anon/environments`, fullMatch: false},
    {path: '/ai-market-hub/project-description/generator', fullMatch: false},
    {path: '/yp-api/project-api/api/anon/projects/search', fullMatch: false}
  ];

  constructor(private encryptService: EncryptService, private router: Router, private httpService: HttpService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url;
    let except = false;
    for (const fURL of this.filterURL) {
      except = fURL.fullMatch ? url === fURL.path : url.includes(fURL.path);
      if (except) {
        break;
      }
    }

    if (!except) {
      req = req.clone({
        responseType: 'text',
        withCredentials: false
      });
      return next.handle(req).pipe(
        mergeMap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            return this.httpService.getCryptoKey().pipe(
              map(cryptoKey => {
                if (cryptoKey) {
                  try {
                    const decrypted = this.encryptService.decryptUsingAES128(event.body, cryptoKey);
                    // body json
                    console.log('body: %s %s %s', event.status, event.url, decrypted);
                    return event.clone({body: JSON.parse(decrypted)});
                  } catch (e) {
                    console.log('Decrypt Error!');
                    this.router.navigate(['/auth/login']).then();
                    throw new HttpErrorResponse({
                      error: 'Decryption Error!',
                      headers: event.headers,
                      status: 200,
                      statusText: 'Warning',
                      url: event.url
                    });
                  }
                } else {
                  return null;
                }
              })
            );
          } else {
            return of(event);
          }
        })
      );
    } else {
      // Normal Request
      return next.handle(req);
    }
  }
}
